module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/swieczki.jpg?26c83d21";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/swieczki.jpg
// module id = 2316
// module chunks = 0